import { createReducer } from "sc/helpers/reducer";
import { SCHEDULE_STATUS_LOADED } from "../actions/schedule-status";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => null,
  [SCHEDULE_STATUS_LOADED]: (state, action) => action.payload.scheduleStatus,
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/schedule-status-reducer.js